module.exports = __webpack_public_path__ + "static/media/mori-arts.51f9c11b.jpeg";